import type React from "react";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import { PortfolioSafetyContent } from "@/pages/portfolio/safety-overview";
import { WorkspaceOverviewPage } from "@/pages/workspace-overview";

export const WorkspacePortfolioOverview: React.FC = () => {
  const { workspace } = useWorkspaceAdmin();
  if (!workspace) return null;

  return <WorkspaceOverviewPage merchants={workspace.merchants} workspaceId={workspace.id} />;
};

export const WorkspacePortfolioSafety: React.FC = () => {
  const { workspace } = useWorkspaceAdmin();
  if (!workspace) return null;

  return <PortfolioSafetyContent merchants={workspace.merchants} workspaceId={workspace.id} />;
};
